import 'nprogress/nprogress.css';

import Vue from 'vue';
import Router from 'vue-router';
import Progress from 'nprogress';

import { staticRoutes, mainRoute, whitelist } from '@/config/router.config';

Vue.use(Router);
Progress.configure({ showSpinner: false });

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: staticRoutes,
});

let loaded = false;

router.beforeEach(async (to, from, next) => {
  Progress.start();

  // 白名单通过
  if (whitelist.includes(to.name)) {
    next();
    return;
  }

  // 装载动态路由，重新跳转
  if (!loaded) {
    loaded = true;
    router.addRoutes([mainRoute]);
    next({ ...to, replace: true });
    return;
  }

  // 跳转到之前缓存的路由
  const redirect = decodeURIComponent(from.query.redirect || '');
  if (redirect && redirect !== to.path) {
    next({ path: redirect });
    return;
  }

  next();
});

router.afterEach(() => {
  Progress.done();
});

export default router;
